import { SVGProps } from "react"

export const Basket = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M8.61828 9.10526V4.47368C8.61828 2.55522 10.1735 1 12.092 1C14.0104 1 15.5656 2.55522 15.5656 4.47368V9.10526M5.31591 23H18.868C20.212 23 21.2737 21.8598 21.1779 20.5192L20.3509 8.94027C20.2643 7.7284 19.2559 6.78947 18.0409 6.78947H6.14298C4.92802 6.78947 3.91963 7.7284 3.83307 8.94027L3.006 20.5192C2.91025 21.8598 3.97196 23 5.31591 23Z"
            stroke="currentColor"
            strokeLinecap="round"
        />
    </svg>
)
